import { z } from 'zod'
import { SupplierRemoteTypeSchema } from '@omnea-app/packages/universal/integrations/supplierRemoteType'

export const SupplierContactSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  email: z.string().min(1),
})

export type SupplierContact = z.infer<typeof SupplierContactSchema>

export const SupplierProductPayloadSupplierSchema = z.object({
  id: z.string().nullable(),
  // TODO: come back here
  name: z.string(),
  isOrgSupplier: z.boolean(),
  isPreferred: z.boolean().optional(),
  legalName: z.string().nullable().optional(),
  remoteLink: z.string().nullable().optional(),
  remoteType: SupplierRemoteTypeSchema.nullable().optional(),
  isActive: z.boolean(),
  state: z.enum(['ACTIVE', 'INACTIVE', 'PENDING', 'ARCHIVED']).optional(),
  type: z.enum(['SUPPLIER', 'NEW_SUPPLIER', 'GLOBAL_SUPPLIER', 'NEW_PRODUCT', 'PRODUCT']).optional(),
  description: z.string().nullable().optional(),
  website: z.string().nullable().optional(),
  terminalCategoryIds: z.array(z.uuid()).optional(),
})

export type SupplierProductPayloadSupplier = z.infer<typeof SupplierProductPayloadSupplierSchema>

export const SupplierProductPayloadSchema = z.object({
  id: z.string().nullable(),
  name: z.string().nullable(),
  description: z.string().nullable().optional(),
  website: z.string().nullable().optional(),
  // Should always be populated going forward, optional for backwards compatibility
  state: z.enum(['ACTIVE', 'INACTIVE', 'PENDING']).optional(),
  supplier: SupplierProductPayloadSupplierSchema.nullable(),
  contacts: z.array(SupplierContactSchema).optional(),
})

export type SupplierProductPayload = z.infer<typeof SupplierProductPayloadSchema>

export const isSupplierProductPayload = (value: any): value is SupplierProductPayload => {
  return (
    typeof value === 'object' &&
    value !== null &&
    'name' in value &&
    'supplier' in value &&
    !!value.supplier &&
    'id' in value.supplier
  )
}
